import NativeSelect from '@mui/material/NativeSelect';
import { useAppTheme } from './AppThemeProvider';

export default function ThemePicker() {
  const { preference, setPreference } = useAppTheme();

  return <div>
    <label className='menuListButton menuListActionButton' style={{ gap: 16 }}>
      <span className='fullWidthButtonText' style={{ flex: 1 }}>Theme</span>
      <NativeSelect
        value={preference}
        onChange={event => setPreference(event.target.value)}
        disableUnderline
        inputProps={{ 'aria-label': 'Theme' }}
        sx={{
          fontSize: 14,
          color: 'text.secondary',
          '& .MuiNativeSelect-icon': { color: 'inherit' },
        }}
      >
        <option value='light'>Light</option>
        <option value='dark'>Dark</option>
        <option value='system'>System</option>
      </NativeSelect>
    </label>
  </div>;
}
